import { CivilQuotation } from './components';

export const StepThree = () => <CivilQuotation />;
